import React, {Component} from 'react';
import {BigButtonTool} from "../../oneLineToolSpace";
import menuPDFIcon from "../../../components/image/menuPDFIcon.png";
import {uuid} from "../../../../../utils";
import PDFUpload from "../../../components/pdfUpload/pdfUpload";
import BaseComponent from "../../../../../base/BaseComponent";
import $ from "jquery"

function base64Encode(str) {
    // 对字符串进行编码
    var encode = encodeURI(str);
    // 对编码的字符串转化base64
    var base64 = btoa(encode);
    return base64;
}

export const buildInsertpdfHtml = ({name, url}) => {
    var pdfWidth = $('#pdfWidth').val();
    var pdfHeight = $('#pdfHeight').val();
    let urlHost =window.location.origin;
    let kkfileUrlHost = window.sysConfigGetValueByKey('pdf_urlHost', 'http://192.168.120.50:413')
    if(urlHost.indexOf('127.0.0.1')>-1) {
        // urlHost = 'http://192.168.120.50:9241'
        urlHost = 'http://192.168.120.50:413'
    }
    let preivewUrl = encodeURIComponent(base64Encode(`${kkfileUrlHost}${url}?fullfilename=${name}`));
    let officeViewUrl = urlHost + '/kkfileview/onlinePreview' + "?url=" + preivewUrl;
    // console.log(name, url,officeViewUrl)
    return `<p>
                <iframe
                    pdfiframe="true"
                    alias-label="pdf"
                    isvsbpdf="true"
                    frameborder="0"
                    imagenum="0"
                    style="border:1px solid #DDDDDD"
                    _src="${url}"
                    src="${officeViewUrl}"
                    title="${name}"
                    width=${pdfWidth}
                    height=${pdfHeight}></iframe>
        </p>`
};

class UploadPDFTool extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            dialog: false,
            dialogKey: uuid(),
            fileList: []
        }
    }

    pdfUploadHandleCancel = () => {
        this.setState({
            dialog: false,
            dialogKey: uuid(),
            fileList:[],
        });
    };
    pdfUploadOk = () => {
        let pdfHTML = '';
        this.state.fileList && this.state.fileList.map(file => {
            pdfHTML += buildInsertpdfHtml({
                ...file,
            });
        });
        let isSuccess = true;
        if (pdfHTML) {
            isSuccess = this.props.editor.rmtExecCommand("inserthtml", pdfHTML);
        }
        if (isSuccess) {
            this.pdfUploadHandleCancel();
        }
    };

    render() {
        return (
            <div
                style={{position: 'relative'}}
                onClick={() => {
                    this.setState({isHover: "none"})
                }}
            >
                <BigButtonTool src={menuPDFIcon} text={"PDF"} height={this.props.height}
                               width={this.props.width}
                               onClick={() => {
                                   this.setState({dialog: true})
                               }}
                />
                <PDFUpload
                    key={this.state.dialogKey}
                    pdfUpload={this.state.dialog}
                    handleOk={() => this.pdfUploadOk()}
                    handleCancel={() => this.pdfUploadHandleCancel()}
                    fileListCall={(fileList) => {
                        if (fileList) {
                            this.setState({fileList})
                        }
                    }}
                />
            </div>
        );
    }
}

export default UploadPDFTool;